export { AdBounded as Bounded } from "./adBounded";
export { AdHero as Hero } from "./adHero";
export { AdLabel as Label } from "./adLabel";
export { AdPrimary as Primary } from "./adPrimary";



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/ad.ts
// module id = 71+K
// module chunks = 2